<script setup lang="ts">
import { Check } from 'lucide-vue-next'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  error: {
    type: Boolean,
    required: false,
  },
  id: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    required: false,
  },
  type: {
    type: String,
    required: false,
  },
  inputType: {
    type: String,
    required: false,
  },
  completion: {
    type: String,
    required: false,
    default: '',
  },
  cyrillicOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
  dynamicPlaceholder: {
    type: String,
    required: false,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'focus', 'blur', 'selectSuggestion'])
const modelValue = defineModel({ type: String, default: '' })

const isFocused = ref(false)
const attrs = useAttrs()

function handleInput(event: Event) {
  if (props.cyrillicOnly) {
    event.preventDefault()
    event.stopPropagation()
    const input = event.target as HTMLInputElement
    // eslint-disable-next-line regexp/no-obscure-range
    input.value = input.value.replace(/[^А-ЯЁа-яё0-9\s.,-]+$/g, '')
  }
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}

function handleFocus(event: FocusEvent) {
  isFocused.value = true
  emit('focus', event)
}
function handleBlur(event: Event) {
  isFocused.value = false
  emit('blur', event)
}
</script>

<template>
  <div class="relative w-full">
    <FloatingLabelInput
      :id="id"
      v-model="modelValue"
      :completion="completion"
      :label="label"
      :error="error"
      :placeholder="placeholder"
      :type="type"
      :input-type="inputType"
      v-bind="attrs"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="handleInput"
    />
  </div>
</template>

<style scoped>
input::placeholder {
  font-weight: normal !important;
  opacity: 0.5;
}
</style>
